import { useState, useCallback } from 'react';

const useLoadSources = () => {
    const [pendingSources, setPendingSources] = useState([]);
    const removeItem = (sourceId) => {
        setPendingSources((prevState) => prevState.filter((prevItem) => prevItem.id !== sourceId));
    };
    const loadPendingSources = useCallback((sources) => {
        if (sources?.length) {
            setPendingSources(sources);
            const scriptElm = document.createElement('script');
            sources.forEach((source) => {
                const scriptNode = document.getElementById(source.id);
                if (scriptNode) {
                    removeItem(source.id);
                    return;
                }
                const scriptLoaded = (event) => {
                    removeItem(source.id);
                    document.removeEventListener(event.type, scriptLoaded, false);
                };
                const scriptError = (event) => {
                    removeItem(source.id);
                    document.getElementById(source.id)?.remove();
                    document.removeEventListener(event.type, scriptError, false);
                };
                document.addEventListener(`${source.id}-error`, scriptError);
                document.addEventListener(source.id, scriptLoaded);
                scriptElm.appendChild(document.createTextNode(source.code));
            });
            document.body.appendChild(scriptElm);
            document.body.removeChild(scriptElm);
        }
    }, []);
    return { pendingSources, loadPendingSources };
};

export { useLoadSources as default };
//# sourceMappingURL=useLoadSources.js.map
